import { useSelector } from "react-redux"
import { HeaderLabels } from "../constants/constants";
import "../styles/header.scss";



const Header = () => {

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    return (
        <div className = "header">
             <div className = "header__title">{HeaderLabels.labels.title[currentLanguage]}</div>
        </div>
       
    )
}

export default Header